export default "__VITE_PUBLIC_ASSET__a4324c2b__"